import { createFileRoute } from '@tanstack/react-router';
import { ReportDetailPage } from '@/components/finance';

interface ReportDetailSearch {
  /** The gift, loan or spending whose 72/24-hour notice the page offers to upload, from the notice's card. */
  notice?: string;
}

export const Route = createFileRoute('/admin/finance/reports/$reportId')({
  validateSearch: (search: Record<string, unknown>): ReportDetailSearch => ({
    notice: typeof search.notice === 'string' ? search.notice : undefined,
  }),
  component: ReportDetailRoute,
});

function ReportDetailRoute() {
  const { reportId } = Route.useParams();
  const { notice } = Route.useSearch();
  return (
    <div className="p-6">
      <ReportDetailPage reportId={reportId} noticeOf={notice ?? null} />
    </div>
  );
}
